import { captureBrowserException, initBrowserSentry } from 'ai-sl-sentry';

export function initSentry(): void {
  initBrowserSentry({
    serviceName: 'backend-gui',
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE,
    ...(import.meta.env.VITE_SENTRY_RELEASE
      ? { release: import.meta.env.VITE_SENTRY_RELEASE }
      : {}),
    sampleRate: 1.0,
    installWindowHandlers: true,
  });
}

export function captureException(
  error: unknown,
  context?: { componentStack?: string | null },
): void {
  captureBrowserException(error, {
    microservice: 'backend-gui',
    ...(context?.componentStack ? { componentStack: context.componentStack } : {}),
  });
}
